const firebaseConfig = {
    apiKey: "AIzaSyAuSMIRtIktd3oPLQfsmSA_Hqx6qZKtVL8",
    authDomain: "bistora-a50f7.firebaseapp.com",
    projectId: "bistora-a50f7",
    storageBucket: "bistora-a50f7.appspot.com",
    messagingSenderId: "960794948995",
    appId: "1:960794948995:web:037078f01275e05b9932b6"
  };

export default firebaseConfig;  